import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'navigate-away-component',
  templateUrl: './navigate-away.component.html',
  styleUrls: ['./navigate-away.component.scss'],
})
export class NavigateAwayComponent {
  constructor(public router: Router, public sharedService: SharedService, public ga: GoogleAnalyticsService) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && this.sharedService.navigateAwayModalState) {
        this.sharedService.hideNavigateAwayModal();
      }
    });
  }

  leave() {
    this.sharedService.navigateAwayConfirmation = true;
    this.router.navigate([this.sharedService.navigateAwayUrl], {
      queryParams: this.sharedService.navigateAwayQueryParams,
    });
  }

  stay() {
    this.sharedService.navigateAwayConfirmation = false;
    this.sharedService.hideNavigateAwayModal();
  }
}
